import React, { HTMLAttributes } from 'react';

const Card = (properties: HTMLAttributes<HTMLDivElement>) => {
  const { children, className, ...remainingProperties } = properties;
  return (
    <div
      {...remainingProperties}
      className={`bg-theme-darker-gray rounded-lg ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
